module.exports = __webpack_public_path__ + "img/chap.681951d4.png";